import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, Dropdown, Container } from "react-bootstrap";
import { appConfig } from '../../config/app';
import BrandLogo from '../shared/BrandLogo';
import { isPaidSubscriber } from '../../utils/AuthorizationCheck';

const HeaderLoggedInMobile = ({auth}) => { 
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setShowDropdown(false);
        }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    // Add null checks to prevent errors when auth data is still loading
    const userInitial = auth?.user?.first_name ? auth.user.first_name.charAt(0).toUpperCase() : null;

    // Don't render if auth data isn't loaded yet
    if (!auth || !auth.user || !auth.user.permission) {
        return (
            <div className="d-block d-lg-none mb-3">
                <Navbar fixed="top" collapseOnSelect expand="xl" variant="dark" className="navbar-glass">
                    <Container fluid>
                        <Navbar.Brand>
                            <BrandLogo linkTo="/dashboard" />
                        </Navbar.Brand>
                    </Container>
                </Navbar>
            </div>
        );
    }

    return (
        <>
        <div className="d-block d-lg-none mb-3">
            <Navbar fixed="top" collapseOnSelect expand="xl" variant="dark" className="navbar-glass">
                <Container fluid>
                    <Navbar.Brand>
                        <BrandLogo linkTo="/dashboard" />
                    </Navbar.Brand>                                                            

                    {/* Centered League Dropdown */}
                    {/* <div className="d-flex align-items-center me-3">
                        <Dropdown>
                            <Dropdown.Toggle 
                                variant="outline-light" 
                                size="sm"
                                className="league-switcher-toggle"
                                style={{ fontSize: "0.8rem", padding: "0.25rem 0.5rem" }}
                            >
                                <i className="bi bi-trophy me-1 text-warning"></i>
                                All
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="league-switcher-menu">
                                <Dropdown.Item className="active">All Leagues</Dropdown.Item>
                                <Dropdown.Item>Friends League</Dropdown.Item>
                                <Dropdown.Item>Work League</Dropdown.Item>
                                <Dropdown.Item>Family League</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div> */}

                    {/* Right Side Elements - Discord + Avatar */}
                    <div className="d-flex align-items-center ms-auto">
                        {/* Discord Logo */}
                        <a 
                            href={appConfig.social.discord}
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ fontSize: '2rem', color: '#5865f2', marginRight: '1rem' }}
                        >
                            <i className="fab fa-discord"></i>
                        </a>

                        {/* Avatar Dropdown */}
                        <div className="d-flex align-items-center pe-2" ref={dropdownRef}>
                            <Dropdown show={showDropdown} onToggle={() => {}}>
                                <div
                                as="div"
                                onClick={() => setShowDropdown(!showDropdown)}
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    backgroundColor: 'var(--accent-primary)',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    fontSize:"0.9em",
                                }}
                                >
                                    {userInitial === null ? <i className="bi bi-person-fill fs-5" ></i> : userInitial}
                                </div>

                                <Dropdown.Menu align="end" show={showDropdown} className="custom-dropdown-menu p-0" style={{minWidth:"200px"}}>
                                    {/* Upgrade link for non-paid subscribers */}
                                    {!isPaidSubscriber(auth) && (
                                        <Dropdown.Item 
                                            as={Link}
                                            to="/onboarding/plan" 
                                            className="pb-2 d-inline-flex align-items-center" 
                                            style={{ color:"var(--accent-accent)"}}
                                            onClick={() => setShowDropdown(false)}
                                        >
                                            <i className="bi bi-credit-card me-2"></i>
                                            Upgrade
                                        </Dropdown.Item>
                                    )}
                                    
                                    <Dropdown.Item 
                                        as={Link}
                                        to="/dashboard" 
                                        className="pb-2 d-inline-flex align-items-center" 
                                        style={{ color:"var(--text-secondary)"}}
                                        onClick={() => setShowDropdown(false)}
                                    >
                                        <i  className="bi bi-speedometer2" 
                                            style={{
                                                marginRight: "0.6rem",
                                                lineHeight: ".8",       
                                                verticalAlign: "middle",
                                                color:"var(--text-secondary)"
                                            }}
                                        ></i> Dashboard
                                    </Dropdown.Item>

                                    <Dropdown.Divider className="m-0"/>
                                    
                                    <Dropdown.Item 
                                        as={Link}
                                        to="/settings" 
                                        className="py-2" 
                                        style={{ color:"var(--text-secondary)"}}
                                        onClick={() => setShowDropdown(false)}
                                    >
                                        <i className="bi bi-gear me-2"></i>
                                        Settings
                                    </Dropdown.Item>

                                    <Dropdown.Item 
                                        as={Link}
                                        to="/contact" 
                                        className="pb-2" 
                                        style={{ color:"var(--text-secondary)"}}
                                        onClick={() => setShowDropdown(false)}
                                    >
                                                                                    <i className="bi bi-chat-dots me-2"></i>
                                        Contact
                                    </Dropdown.Item>

                                    <Dropdown.Divider className="m-0"/>
                                    <Dropdown.Item 
                                        as={Link}
                                        to="/logout" 
                                        className="py-2"
                                        style={{ color:"var(--text-secondary)"}}
                                        onClick={() => setShowDropdown(false)}
                                    >
                                        <i className="bi bi-box-arrow-right me-2"></i>
                                        Logout
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown> 
                        </div>
                    </div>
                </Container>
            </Navbar>
        </div>
        </>
    )
}

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(HeaderLoggedInMobile);